import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import Header from "design-system/resources/html/components/common/header/header";
import NavbarMobile from "design-system/resources/html/components/common/navbar-mobile/navbar-mobile";

import ResponsiveTable from "design-system/resources/html/components/common/responsive-table/responsive-table";

import RiskWarningBar from "design-system/resources/html/components/common/risk-warning-bar/risk-warning-bar";

import getIdCarouselForAutoSlide from "./carousel";
import messengerSet from "design-system/resources/html/components/common/messengers/messengers";
import setupLanguageSwitcher from './language-switcher';

window.onload = function () {
  Header();
  setupLanguageSwitcher();
  NavbarMobile();
  getIdCarouselForAutoSlide();
  ResponsiveTable();
  RiskWarningBar();
  messengerSet();
};